import { enhancedFetch, ssrBuilder } from 'journey-ui'
import { NextPageContext } from 'next'
import React from 'react'
import { AppPage } from '../components/AppPage'
import { CartDisplay } from '../components/Menu/CartDisplay'
import { BrandHeader } from '../components/BrandHeader'
import { redirectIfNoBrand } from '../helpers'

type Props = {
  brand: Brand
}

const CartPage: React.FC<Props> = ({ brand }) => (
  <AppPage brand={brand} title="Cart" description="View the items in your cart, update quantities, and checkout." className="full-screen">
    <BrandHeader className="h-20">
      <h2 className="text-3xl z-20 font-bold">
        Cart
      </h2>
    </BrandHeader>
    <CartDisplay />
  </AppPage>
)

export default CartPage

export async function getServerSideProps(ctx) {
  return ssrBuilder(ctx)
    .setProp('brand', (fetcher) => fetcher(`/api/brand/${ctx.req.headers.host}`))
    .onError(redirectIfNoBrand)
    .get()
}
